/** @prettier */

import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import createAccessibleOnClick from '../../../utils/createAccessibleOnClick';
import { useHover } from '../../../hooks/useHover';

const containerClass = isHovering =>
  classNames({
    'sl-fullscreen-toggle-container': true,
    'sl-fullscreen-toggle-container--hover': isHovering,
  });

const FullscreenIcon = ({ isFullscreen, onClick }) => {
  const { hoverProps, isHovering } = useHover({
    className: 'sl-fullscreen-toggle-button',
  });

  return (
    <div className={containerClass(isHovering)}>
      <button type="button" {...createAccessibleOnClick(onClick)} {...hoverProps}>
        <svg
          width="22px"
          height="20px"
          viewBox="0 0 20 22"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            {isFullscreen ? (
              <path
                d="M17.8612134,9.77533628 L13.289115,9.77287863 C12.702725,9.77256343 12.2274406,9.2972795 12.2271247,8.71088954 L12.2246619,4.13878536 C12.2243458,3.55194887 12.6998145,3.07596765 13.286651,3.07565154 C13.2870342,3.07565133 13.2874175,3.07565133 13.2878008,3.07565154 L13.3083111,3.07566269 C13.8946996,3.07598137 14.3699806,3.55126575 14.3702951,4.13765419 L14.3713534,6.11063737 L20.1707709,0.311217163 C20.5857268,-0.103739229 21.2585036,-0.103739385 21.6734598,0.31121664 L21.6887832,0.326540333 C22.103739,0.741496561 22.1037391,1.41427323 21.6887833,1.82922955 L15.8893655,7.62865011 L17.8623435,7.62970841 C18.4487334,7.63002295 18.9240184,8.10530625 18.924335,8.69169616 L18.9243461,8.71220111 C18.9246629,9.2990376 18.4491948,9.77501943 17.8623583,9.77533628 C17.8619767,9.77533648 17.8615951,9.77533649 17.8612134,9.77533628 Z M4.13878656,12.2246637 L8.710885,12.2271214 C9.29727496,12.2274366 9.77255943,12.7027205 9.7728753,13.2891105 L9.77533813,17.8612146 C9.77565423,18.4480511 9.30018552,18.9240324 8.71334903,18.9243485 C8.71296575,18.9243487 8.71258247,18.9243487 8.7121992,18.9243485 L8.69168886,18.9243373 C8.10530042,18.9240186 7.63001941,18.4487343 7.62970488,17.8623458 L7.62864657,15.8893626 L1.82923416,21.6887777 C1.41427831,22.1037341 0.741501509,22.1037343 0.326545291,21.6887783 L0.311221947,21.6734546 C-0.103733932,21.2584983 -0.10373401,20.5857217 0.311221772,20.1707653 L6.11063453,14.3713499 L4.13765651,14.3702916 C3.55126661,14.369977 3.07598163,13.8946937 3.07566501,13.3083038 L3.07565394,13.2877989 C3.07533709,12.7009624 3.5508052,12.2249806 4.13764169,12.2246637 C4.13802331,12.2246635 4.13840494,12.2246635 4.13878656,12.2246637 Z"
                id="fullscreen-toggle-1"
              />
            ) : (
              <path
                d="M16.3607808,1.53580888e-07 L20.935043,0.00245896412 C21.5217104,0.00277431643 21.9972198,0.478283167 21.9975358,1.06495063 L21.9999998,5.63921618 C22.0003161,6.22633038 21.5246224,6.70253686 20.9375082,6.70285312 C20.9371247,6.70285332 20.9367413,6.70285332 20.9363578,6.70285311 L20.9158378,6.70284196 C20.3291718,6.70252313 19.8536659,6.22701383 19.8533512,5.64034789 L19.8522924,3.66643207 L14.050131,9.46859415 C13.6349786,9.88374671 12.9618834,9.88374675 12.5467309,9.46859428 L12.5314005,9.45326386 C12.1162481,9.03811134 12.1162481,8.36501619 12.5314005,7.94986364 L18.333562,2.14770147 L16.3596503,2.14664267 C15.7729828,2.14632798 15.2974729,1.67081976 15.2971562,1.08415235 L15.2971451,1.06363844 C15.2968281,0.476524241 15.7725212,0.000317158078 16.3596354,1.54956946e-07 C16.3600172,-5.11927789e-08 16.360399,-5.16514653e-08 16.3607808,1.53580888e-07 Z M5.63921916,21.9999998 L1.06495702,21.997541 C0.478289556,21.9972257 0.00278016738,21.5217168 0.00246415062,20.9350494 L1.57536112e-07,16.3607838 C-0.000316099866,15.7736696 0.475377624,15.2974631 1.06249183,15.2971469 C1.06287529,15.2971467 1.06325875,15.2971467 1.06364221,15.2971469 L1.08416224,15.297158 C1.67082819,15.2974769 2.14633412,15.7729862 2.14664881,16.3596521 L2.14770761,18.3335679 L7.9498703,12.5314046 C8.36502272,12.116252 9.03811791,12.116252 9.45327043,12.5314044 L9.46860076,12.5467349 C9.88375319,12.9618874 9.88375321,13.6349825 9.4686008,14.0501351 L3.66643803,19.8522985 L5.64034974,19.8533573 C6.22701715,19.853672 6.70252706,20.3291802 6.70284382,20.9158477 L6.70285489,20.9363616 C6.7031719,21.5234758 6.22747878,21.9996828 5.64036458,21.9999998 C5.63998277,22.0000001 5.63960097,22.0000001 5.63921916,21.9999998 Z"
                id="fullscreen-toggle-1"
              />
            )}
          </defs>
          <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <mask fill="white">
              <use xlinkHref="#fullscreen-toggle-1" />
            </mask>
            <use
              className="sl-fullscreen-toggle-button__shape"
              fill={isHovering ? '#0058B0' : '#333333'}
              xlinkHref="#fullscreen-toggle-1"
            />
          </g>
        </svg>
      </button>
    </div>
  );
};

FullscreenIcon.propTypes = {
  isFullscreen: PropTypes.bool,
  onClick: PropTypes.func,
};

FullscreenIcon.defaultProps = {
  isFullscreen: false,
  onClick: () => {},
};

export default FullscreenIcon;
